<script lang="ts">
    import { onMount } from "svelte"
    import { animateOnVisible } from "../../../configs/config"
    import Markdown from "./Markdown.svelte"

    interface Props {
        block: Block<"accordeons">
    }
    let { block }: Props = $props()
    let activeAccordeons: Record<number, boolean> = $state({})
    onMount(() => {
        const items = document.querySelectorAll(".container-t .accordion-trigger .icon")
        animateOnVisible(items, {
            duration: 500,
            delay: (_target: Element, idx: number) => 100 * idx,
            easing: "cubicBezier",
            opacity: [0, 1],
        })
    })
</script>

<div class="container-t">
    {#each block.content.accordeons as box, idx}
        <article class="teaser-box">
            <div class="content">
                {#if box.title}
                    <button
                        class="accordion-trigger"
                        class:active={activeAccordeons[idx]}
                        aria-expanded={activeAccordeons[idx]}
                        onclick={() => (activeAccordeons[idx] = !activeAccordeons[idx])}
                    >
                        <h3>
                            {box.title}
                        </h3>
                        <span class="icon" aria-hidden="true">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="24"
                                viewBox="0 0 14 24"
                                fill="none"
                            >
                                <path
                                    d="M12.2498 15.8788L7.74991 20.3786V0.820312H6.24991V20.3785L1.75009 15.8788L0.689453 16.9394L6.99995 23.2499L13.3105 16.9394L12.2498 15.8788Z"
                                    fill="#242220"
                                ></path>
                            </svg>
                        </span>
                    </button>
                {/if}

                <div class="box-text" class:hidden={box.title && !activeAccordeons[idx]}>
                    <Markdown text={box.content} />
                </div>
            </div>
        </article>
    {/each}
</div>

<style lang="less">
    .container-t {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        * {
            color: var(--on-background);
        }
        article {
            padding: 0px;
            margin: 0px;
        }
        .accordion-trigger {
            align-items: center;
            cursor: pointer;
            background: none;
            border: none;
            padding: 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            h3 {
                margin: 0px;
                text-align: left;
                border-bottom: none;
                color: var(--dark-100);
            }
            .icon {
                font-size: 1.5em;
                width: 1.2rem;
                height: 1.2rem;
                display: flex;
                justify-content: center;
                transition: transform 0.3s;
            }

            &.active .icon {
                transform: rotate(180deg);
            }
        }

        .box-text.hidden {
            display: none;
        }

        .teaser-box {
            width: 100%;
            margin-bottom: 2rem;
            border-bottom: 1px solid var(--stroke-100);
            padding-bottom: 1rem;
        }

        .content {
            padding: 0px;
        }
    }
</style>
